import TopMenu from "../components/topMenu";
import {Button, Card, Col, Container, FormControl, FormGroup, FormLabel, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useForm, Controller} from "react-hook-form";
import {createUseStyles} from "react-jss";
import axios from "axios";
import Helper from "../helper";
import Error from "../components/error";
import {NotificationManager} from "react-notifications";

const useStyles = createUseStyles({
    card_login: {
        '& div:nth-child(n+1)': {
            marginBottom: 5
        }
    }
});


const Register = () => {
    const {register, handleSubmit, control, reset, getValues, formState: {errors}} = useForm({
        defaultValues: {
            first_name: '',//'สุณี',
            last_name: '',//'เลิศสินอุดม',
            license_id: '',//'7726',
        }
    });

    const onSubmit = data => {
        axios.post(Helper.URI('register'), data).then(res => {
            if(res.data.error){
                NotificationManager.error(res.data.error);
            }else{
                NotificationManager.success('ลงทะเบียนสำเร็จ');
                setTimeout(()=>{
                    document.location.href=sessionStorage.getItem('backLink');
                },2000);
            }
        })
    }

    const classes = useStyles();
    return <>
        <TopMenu/>
        <Container>
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={5}>
                    <Card className={classes.card_login}>
                        <Card.Header>
                            <h3>ลงทะเบียน</h3>
                        </Card.Header>
                        <Card.Body>
                            <FormGroup>
                                <FormLabel>ชื่อ</FormLabel>
                                <FormControl {...register('first_name', {required: "กรุณากรอกชื่อ"})}/>
                                <Error>{errors?.first_name?.message}</Error>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>นามสกุล</FormLabel>
                                <FormControl {...register('last_name', {required: "กรุณากรอกนามสกุล"})}/>
                                <Error>{errors?.last_name?.message}</Error>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>เลขใบประกอบวิชาชีพ (ระบุเฉพาะตัวเลข)</FormLabel>
                                <FormControl {...register('license_id', {
                                    required: "กรุณากรอก เลขใบประกอบวิชาชีพ",
                                    pattern: {
                                        value: /^[0-9]+$/,
                                        message: "เลขใบประกอบวิชาชีพ ต้องเป็นตัวเลขเท่านั้น"
                                    },
                                    validate:{
                                        already:async v=>{
                                            let result = await axios.post(Helper.URI('check-license'),{license_id:v})
                                            if(result.data?.existed){
                                                return 'License ID นี้มีผู้ลงทะเบียนแล้ว';
                                            }else{
                                                return true;
                                            }
                                        }
                                    }
                                })}/>
                                <Error>{errors?.license_id?.message}</Error>
                                {/*<Error>{errors?.license_id?.already}</Error>*/}
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>อีเมล</FormLabel>
                                <FormControl {...register('email', {
                                    required: "กรุณากรอกอีเมล",
                                    pattern: {
                                        value: /\S+@\S+\.\S+/,
                                        message: "กรุณากรอกอีเมลให้ถูกต้อง"
                                    }
                                })}/>
                                <Error>{errors?.email?.message}</Error>
                            </FormGroup>
                            {/*<FormGroup>*/}
                            {/*    <FormLabel>Username</FormLabel>*/}
                            {/*    <FormControl {...register('username', {required: "กรุณากรอก Username"})}/>*/}
                            {/*    <Error>{errors?.username?.message}</Error>*/}
                            {/*</FormGroup>*/}
                            <FormGroup>
                                <FormLabel>Password</FormLabel>
                                <FormControl type='password' {...register('password', {
                                    required: "กรุณากรอก Password",
                                    pattern: {
                                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/,
                                        message: "ต้องมีตัวอักษร(เล็ก-ใหญ่) และตัวเลขรวมกันอย่างน้อย 6 หลัก เช่น Abc123"
                                    }
                                })}/>
                                <Error>{errors?.password?.message}</Error>
                            </FormGroup>
                            <FormGroup>
                                <FormLabel>ยืนยัน Password</FormLabel>
                                <FormControl type='password' {...register('cpassword', {
                                    required: "กรุณากรอกยืนยัน Password", validate: {
                                        matched: v => {
                                            let password = getValues('password');
                                            return v === password ? true : 'คุณกรอกรหัสผ่านไม่ตรงกัน';
                                        }
                                    }
                                })}/>
                                <Error>{errors?.cpassword?.message}</Error>
                                <Error>{JSON.stringify(errors?.cpassword?.matched)}</Error>
                            </FormGroup>
                            <Row className='mt-4 justify-content-center'>
                                <Col md={12}>
                                    <Button style={{width: '100%'}} onClick={e => {
                                        handleSubmit(onSubmit)()
                                    }}>สมัคร</Button>
                                </Col>
                                <Col md={12}>
                                    <div className='mt-2 text-end'>
                                        {sessionStorage.getItem('backLink')?
                                            <a href={sessionStorage.getItem('backLink')}>กลับไปหน้าเข้าสู่ระบบ</a>
                                            :
                                            <Link to={'/login'}>กลับไปหน้าเข้าสู่ระบบ</Link>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
}
export default Register;
